import React, { Component, PureComponent, useContext, useState, useEffect } from 'react';
import {NavLink, Link, Switch, Route, Redirect} from 'react-router-dom'
import {RootRouterContext} from '../../index.js'
import OurStoryPage from './OurStoryPage'
import Catering from './Catering'
import Taconight from './Taconight'
import Order from './Order'
import RestaurantMap from './ReataurantMap.js';
import Headers from './Headers'
// import AutoMenu from './AutoMenu'
import AutoMenu from '../../react/AutoMenu'
import CartBar from './CartBar'
import LocationsView from './LocationsView'
import FormJob from './FormJob'
import ScrollToTop from '../../react/ScrollToTop.js';
import BakeryVideo from "./BakeryVideo"
import FeaturedProducts from './FeaturedProducts.js';
import HamburgerMenu from './HamburgerMenu.js';
import './index.scss'
import './altStyleA.scss'
import LogoBar from './svg/LogoBar'
import './ThemeToggle/theme_night.scss'
import {Helmet} from "react-helmet";
import { InstagramEmbed } from 'react-social-media-embed';

export const customOrderAppPaths = ["/menu", "/order"]
export const StickyTopBar = () => { return null }

export const locations = [
  {shopId: "jojos",     basePath: "/westhollywood", cssGlobalPrefix: 'pablitoschicken'},
  
  // {shopId: "kokorollhollywood",    basePath: "/hollywood", cssGlobalPrefix: 'kokorollburbank'},
]

export const pages = [
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
  // {path: '/jobs', label: 'Jobs', component: ()=> <FormJob></FormJob> },

  {path: "/hqusers/storeRedirect/:anything", label: "Catering", hideFromNav: true, component: () => <Redirect to="/"></Redirect>},
  // {path: "/taco-night", label: "Event", component: Taconight},
  // {path: "/order-altadena", label: "Menu", component: OrderAltadena},
]

export function SiteNav ({shopId}) {

    const {rootHistory} = useContext(RootRouterContext)


    return (
      <>
      <CartBar shopId={shopId}></CartBar>
    <nav role="navigation" aria-label="navigation">
    
   
  </nav>
  </>
  )
}



export function MultilocationHome () {
  const [shops, setShops] = useState([])
  // useEffect(() => {
  //   const fetchShops = async () => {
  //     // fetch 2 shops shiso and shisooaks

  //     const fetchShiso = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shiso`);
  //     const fetchShisooaks = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shisooaks`);
      
  //     const [shisoResponse, shisooaksResponse] = await Promise.all([fetchShiso, fetchShisooaks]);
      
  //     const shisoData = await shisoResponse.json();
  //     shisoData.text.shopId = 'shiso'
  //     const shisooaksData = await shisooaksResponse.json();
  //     shisooaksData.text.shopId = 'shisooaks'
      
  //     setShops([shisoData.text, shisooaksData.text]);
  //   }
  //   fetchShops()
  // }, [0])

  // console.log("shops:", shops)


  const theme = "light"
  const heroLogoUrl = (theme !== 'dark') ?
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format" :
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format"

  return(
    <div className={"site-content pablitoschicken" + " " + theme}>
      <Headers></Headers>

      <div role="navigation" aria-label="primary" className="cart-wrapper">
      
            <div className="cart minimized">
              <div className="home-link-wrapper">
                <h2>
                  <Link to="/" 
                  aria-label={"Jojos Mediterranean Grill"}
                  className="home-link" aria-label="home page">
                         {/* <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/pablitos-pizza/logo.png?h=400&auto=format"}
                          alt="Pablito's Mexican Pizza"
                        /> */}
                     <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/jojos-mediterranean-grill/logo-1.png?w=500&auto=format"}
                          alt="Jojos Mediterranean Grill"
                   />
                    {/* <span className="text-logo">{!logo && shop.name && shop.name.en}</span> */}
                  </Link>
                </h2>
      
              </div>
      
      
      
              <div className="site-nav-bar" aria-labelledby="shopping-cart-link">
                {/* {showCashback ? <span className="cashback-amount">
                  ${cashback / 100}
                </span> : null} */}
                  {/* <Link className="nav-bar-link secondary" to="/our-story" aria-label="our-story">
                    Our Story
                  </Link>
                  <Link className="nav-bar-link secondary" to="/catering" aria-label="catering">
                    Catering
                  </Link> */}
                  <a className="nav-bar-link call-to-action" href="/westhollywood/order" aria-label="order">
                    Order
                  </a>


                 <HamburgerMenu></HamburgerMenu>
           
                  

                {/* <Link
                id="shopping-cart-link"
                  aria-label="shopping cart"
                  aria-label="shopping cart"
                  to={{pathname: "/checkout", state: {fromMini: true}}}
                  className="checkout-button button">Order Online</Link> */}
              </div>
      
      
      
            </div>
          </div>
    
      <div className="home-page-hero" role="banner" aria-labelledby="hero-link">
        <div>
          <Link to="/" aria-label="Kluckin Chicken" id="hero-link" className="hero-link">
          
              {/* <LogoHero
                theme={theme}
                ></LogoHero> */}
            {/* <img
              className="hero-logo"
               src={heroLogoUrl} alt={"Kluckin Chicken"}/> */}
          </Link>
        </div>
      </div>



      {/* <div className="promo">
        <div style={{
          maxWidth: "400px"
        }} className="figure">

        <img style={{width: "100%"}} src="https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format" alt="" />
        </div>
      </div> */}
  
      <Switch>
        <Route path="/order" component={Order} />
        <Route path="/online-ordering" component={Order} />
        <Route path="/about-us" component={Order} />
        <Route path="/menu" component={Order} />
        <Route path="/locations" component={Order} />
        <Route path="/catering" component={Catering} />
        <Route path="/taco-night" component={Taconight} />
        <Route path="/" exact render={() => {
          return(<MultiHeader shops={shops}></MultiHeader>)
        }}></Route>
        <Route path="/hqusers/storeRedirect/:anything" render={() => {
          return(<Redirect to="/"></Redirect>)
        }}></Route>
        {/* <MultiHeader></MultiHeader> */}
      </Switch>
    </div>
  )
}

function ContactPage () {
  return(
    <div className="contact-page">
      <div className="contact-page-content">
        <h2>How Are We Doing?</h2>
        <p>
        We value your feedback at Kluckin Chicken. If you have recently visited one of our locations, please take a moment to call our corporate office <a href="tel:+19195823222">818-582-3222</a> and let us know how we did. Your input helps us improve our service and the overall customer experience. Thank you for choosing Kluckin Chicken!
        </p>
      </div>


    </div>
  )
}

function MultiHeader({shops}) {
  return (
    <div className="landing-page-wrapper">
    
      <div className="home-grid">
        <BakeryVideo />
                  <div className="logo-hero-block"><div className="logo-hero-block-img-wrapper"><img src="https://afag.imgix.net/jojos-mediterranean-grill/logo-2.png?w=1000&auto=format" alt="Jojo's Mediterranean Grill" /></div></div>


        {/* <div className="hero-image">
          <img src="https://afag.imgix.net/the-juice-stop/juices.jpg?w=1440&auto=format" alt="Shiso Sushi Nigiri and rolls" />
        </div> */}

        <h2 className="header-text">
         Authentic<br/> Lebanese<br/> & Mediterranean<br/> Cuisine
        </h2>

        <p class="body-text">Welcome to <strong>JoJo’s Mediterranean Grill</strong>, where authentic Lebanese-Mediterranean flavors come to life in the heart of Los Angeles. With convenient locations in <strong>West Hollywood</strong> and <strong>North Hollywood</strong>, we bring you fresh, bold, and flavorful dishes rooted in time-honored traditions.</p>

<p class="body-text">At JoJo’s, we take pride in every plate we serve — from flame-grilled kebabs and creamy hummus to crispy falafel, vibrant salads, and hearty wraps. Our recipes are crafted with care using high-quality ingredients, bringing a true taste of the Mediterranean to your table.</p>

<p class="body-text">Whether you’re dining in, grabbing a quick bite to go, or ordering delivery, JoJo’s is here to satisfy. We also offer <strong>full-service catering</strong> for private parties, corporate events, and celebrations of all sizes.</p>

<p class="body-text">Come experience the warmth of Lebanese hospitality and discover why our guests call JoJo’s “the best authentic Lebanese food in LA.” We look forward to serving you soon!</p>

        {/* 
        <h2 className="header-text">
          Featured Items
        </h2>

        <FeaturedProducts /> */}

        <h2 className="header-text">
          Our Location
        </h2>
        <LocationsView shops={shops} />
      </div>
    </div>
  );
}




export class Header extends PureComponent {
  render() {
    // console.log('header props:', this.props)
    const shopId = this.props.shopId
    const basePath = this.props.basePath
    const locationName = this.props.shopId === 'shiso' ? 'North Hollywood' : 'Sherman Oaks'


    const backgroundULRBase = (basePath === '/shermanoaks') ?
    "https://afag.imgix.net/the-kluckin-chicken/nuggets.jpeg?w=1200&auto=format"
    : "https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format"
    return (
      <div className="location-page">

      <Helmet>
        <title>Shiso Sushi - {locationName} | Order Online</title>
      </Helmet>
      
        <div className="top-banner" style={{
          // backgroundImage: `url(${backgroundULRBase})`,
          // backgroundColor: "rgb(238,143,33)",
          // background:  `url(${backgroundULRBase}), linear-gradient(180deg, rgba(238,143,33,1) 0%, rgba(226,90,39,1) 100%)`,
          // backgroundSize: "contain",
          // background: "black"
        }}> 

        </div>

       

      <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>

        <div className="ordering-menu">
          <AutoMenu
            subMenuFilter={subMenuFilter}
            altStyleA
            // tagsToShow={['pizza']}
            width={500}></AutoMenu>
        </div>
      </div>
    );
  }
}


export function subMenuFilter (subMenu) {
  const tag = subMenu.tag || ''
  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() //0 to 23
  const minutes = now.getMinutes() // 0 to 59
  const isWeekday = [1,2,3,4,5].indexOf(day) !== -1
  const isAllDayBreakfastMenu = tag.indexOf('breakfast') !== -1
  const isHidden = tag.indexOf('hidden') !== -1
  if (tag.indexOf('lunch') !== -1) {
    // thursday promo category
    if (isWeekday && (hours >= 11) && (hours < 16)) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('thursdays-only') !== -1) {
    // thursday promo category
    if (day === 4) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('tuesday-only') !== -1) {
    // thursday promo category
    if (day === 2) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-breakfast') !== -1) {
    if ((day === 1) || (day === 2)) {
      if ((hours > 0) && (hours < 16)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-dinner') !== -1) {
    return true
    // thursday promo category
    // if ((day === 1) || (day === 2)) {
    //   if ((hours > 16)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // } else {
    //   return true
    // }
  }

  if (tag.indexOf('promo-wing-it-wed') !== -1) {
    // wednesday promo category
    if (day === 3) {
      return true
    } else {
      return false
    }
  }

  if (isHidden) {
    return false
  }

  if (isAllDayBreakfastMenu && isWeekday) {
    return false
  }


  return true
}